// Spinner — SVG ring driven by the Tailwind `animate-spin` utility.
// Callers MUST pass a `label` — the element is aria-live="polite"
// with role="status" so screen readers announce the wait. Ring colour
// is always Citycare brand (Inch Worm) with a subtle Firefly track
// per W2.7 — callers do not configure colour.

export type SpinnerSize = 'sm' | 'md' | 'lg'

export interface SpinnerProps {
  label: string
  size?: SpinnerSize
}

const SIZE_CLASSES: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-4',
}

export function Spinner({ label, size = 'md' }: SpinnerProps) {
  return (
    <span role="status" aria-live="polite" className="inline-flex items-center gap-2">
      <span
        aria-hidden="true"
        className={[
          'inline-block animate-spin rounded-full border-current border-t-transparent text-brand',
          'border-b-brand-deep/20 border-l-brand-deep/20',
          SIZE_CLASSES[size],
        ].join(' ')}
      />
      <span className="sr-only">{label}</span>
    </span>
  )
}
